/**
 * The API uses this exact opaque marker when a plan member's source price is
 * hidden. A plain null price without this marker remains incomplete.
 */
export function isMaskedLocalPlanPriceContextVersion(
  value: unknown,
): value is `masked:${string}` {
  return typeof value === 'string' && /^masked:[0-9a-f]{57}$/.test(value);
}
